if (!customElements.get('country-region-switcher')) {
  class CountryRegionSwitcher extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-country-region-toggle]');
      this.menu = this.querySelector('[data-country-region-menu]');

      if (!this.toggle || !this.menu || this.initialized) return;

      this.initialized = true;
      this.handleToggle = this.handleToggle.bind(this);
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);

      this.toggle.addEventListener('click', this.handleToggle);
      document.addEventListener('click', this.handleDocumentClick);
      document.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      if (!this.initialized) return;

      this.toggle.removeEventListener('click', this.handleToggle);
      document.removeEventListener('click', this.handleDocumentClick);
      document.removeEventListener('keydown', this.handleKeydown);
      this.initialized = false;
    }

    handleToggle() {
      const willOpen = this.menu.hidden;
      this.menu.hidden = !willOpen;
      this.toggle.setAttribute('aria-expanded', String(willOpen));
    }

    handleDocumentClick(event) {
      if (!this.contains(event.target)) this.close();
    }

    handleKeydown(event) {
      if (event.key !== 'Escape' || this.menu.hidden) return;

      this.close();
      this.toggle.focus();
    }

    close() {
      this.menu.hidden = true;
      this.toggle.setAttribute('aria-expanded', 'false');
    }
  }

  customElements.define('country-region-switcher', CountryRegionSwitcher);
}
